import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  > div:not(:last-child) {
    margin-bottom: 2rem;
  }

  .__group_buttons {
    text-align: right;
  }
`;
